module.exports = __webpack_public_path__ + "img/8.67d87219.jpg";